import { GermanContractDataDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ContractFieldsProps } from '../lib/types'

export interface EmploymentType {
  value: number
  label: string
}

export interface FlatRateTax {
  value: number
  label: string
}

export interface ActivityType {
  value: number
  label: string
}

export interface PersonalKeyGroup {
  value: number
  label: string
}
export const employmentTypes = (): EmploymentType[] => [
  {
    value: 0,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.0'),
  },
  {
    value: 1,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.1'),
  },
  {
    value: 2,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.2'),
  },
]

export const flatRateTaxes = (): FlatRateTax[] => [
  {
    value: 0,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.0'),
  },
  {
    value: 1,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.1'),
  },
  {
    value: 2,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.2'),
  },
]

export const activityTypes = (): ActivityType[] => [
  {
    value: 0,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.0'),
  },
  {
    value: 1,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.1'),
  },
  {
    value: 2,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.2'),
  },
  {
    value: 3,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.3'),
  },
  {
    value: 4,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.4'),
  },
  {
    value: 5,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.5'),
  },
  {
    value: 6,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.6'),
  },
  {
    value: 7,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.7'),
  },
  {
    value: 8,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.8'),
  },
  {
    value: 9,
    label: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.9'),
  },
]

export const personalKeyGroups = (): PersonalKeyGroup[] => [
  {
    value: 0,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.0'
    ),
  },
  {
    value: 101,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.101'
    ),
  },
  {
    value: 102,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.102'
    ),
  },
  {
    value: 103,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.103'
    ),
  },
  {
    value: 104,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.104'
    ),
  },
  {
    value: 105,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.105'
    ),
  },
  {
    value: 106,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.106'
    ),
  },
  {
    value: 107,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.107'
    ),
  },
  {
    value: 108,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.108'
    ),
  },
  {
    value: 109,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.109'
    ),
  },
  {
    value: 110,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.110'
    ),
  },
  {
    value: 111,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.111'
    ),
  },
  {
    value: 112,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.112'
    ),
  },
  {
    value: 113,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.113'
    ),
  },
  {
    value: 114,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.114'
    ),
  },
  {
    value: 116,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.116'
    ),
  },
  {
    value: 118,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.118'
    ),
  },
  {
    value: 119,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.119'
    ),
  },
  {
    value: 120,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.120'
    ),
  },
  {
    value: 121,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.121'
    ),
  },
  {
    value: 122,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.122'
    ),
  },
  {
    value: 123,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.123'
    ),
  },
  {
    value: 124,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.124'
    ),
  },
  {
    value: 127,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.127'
    ),
  },
  {
    value: 140,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.140'
    ),
  },
  {
    value: 141,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.141'
    ),
  },
  {
    value: 142,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.142'
    ),
  },
  {
    value: 143,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.143'
    ),
  },
  {
    value: 144,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.144'
    ),
  },
  {
    value: 149,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.149'
    ),
  },
  {
    value: 150,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.150'
    ),
  },
  {
    value: 190,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.190'
    ),
  },
  {
    value: 900,
    label: i18n.t(
      'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.900'
    ),
  },
]

export interface GermanContractData {
  loading: boolean
  contractTypes: ContractFieldsProps[]
  employmentTypes: EmploymentType[]
  flatRateTaxes: FlatRateTax[]
  activityTypes: ActivityType[]
  personalKeyGroups: PersonalKeyGroup[]
}

const useFetchGermanContractData = (country: string, notHidden?: boolean): GermanContractData => {
  const { company } = useCurrentSession()
  const { loading, data } = useQuery(GermanContractDataDocument, {
    variables: {
      companyId: company.id,
      notHidden,
    },
    skip: country !== 'de',
  })
  const templateData = data?.contracts.contractTemplatesConnection.nodes[0]
  const contractTypes = templateData?.germanContractType || []

  return {
    loading,
    contractTypes,
    employmentTypes: employmentTypes(),
    flatRateTaxes: flatRateTaxes(),
    activityTypes: activityTypes(),
    personalKeyGroups: personalKeyGroups(),
  }
}

export default useFetchGermanContractData
